import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFormKey } from '../../models/forms';
import { EModalButtonLabel, EModalOutput, EModalSize, IModalButton } from './basic-modal.constants';
import { ITableEvent } from '../basic-table/basic-table.constants';

@Component({
  selector: 'app-basic-modal',
  templateUrl: './basic-modal.component.html',
  styleUrl: './basic-modal.component.scss'
})

export class BasicModalComponent {

  modalButtonLabelEnum = EModalButtonLabel;

  constructor(
    public dialogRef: MatDialogRef<BasicModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData
  ) { }

  get title(): string {
    return (this.modalData && this.modalData.title) || '';
  }

  get text(): string {
    return (this.modalData && this.modalData.text) || '';
  }

  get form(): FormGroup {
    return (this.modalData && this.modalData.form) || null;
  }

  get formKeys(): IFormKey[] {
    return (this.modalData && this.modalData.formKeys) || null;
  }

  get tableKeys(): any[] {
    return (this.modalData && this.modalData.tableKeys) || null;
  }

  get tableValues(): any[] {
    return (this.modalData && this.modalData.tableValues) || null;
  }

  get modalSize(): EModalSize {
    return (this.modalData && this.modalData.modalSize) || 'modal-box';
  }

  get buttons(): IModalButton[] {
    return (this.modalData && this.modalData.buttons) || null;
  }

  close(button: IModalButton) {
    switch (button?.output) {
      case EModalOutput.CONFIRM:
      case EModalOutput.YES:
      case EModalOutput.CLOSE:
      case EModalOutput.NO:
      case EModalOutput.UNDERSTOOD_BUTTON:
      case EModalOutput.BACK_TO_POLICY_BUTTON:
      case EModalOutput.BACK:
        this.dialogRef.close(button?.output);
        break;
      case EModalOutput.ADD:
        this.dialogRef.close({
          output: button?.output,
          rawValue: this.form.getRawValue()
        });
        break;
    }
  }

  onActionRequested(event: ITableEvent<any>) {
    this.dialogRef.close(event);
  }

  isButtonDisabled(button: IModalButton): boolean {
    let isButtonDisabled: boolean = false;
    switch (button?.output) {
      case EModalOutput.ADD:
        isButtonDisabled = !this.form.valid;
        break;
      default:
        break;
    }
    return isButtonDisabled;
  }

}